import React, { useState, useEffect } from "react";
import firebase from "firebase";
import { ResetData } from "./AdminData";
import styled from "styled-components";
import { data as CardFlipData } from "./CardFlipData";

function CardView() {
  const [cardData, setCardData] = useState(null);

  useEffect(() => {
    function doSetCardData(snapshot) {
      setCardData(snapshot.val());
    }
    firebase
      .database()
      .ref(`people`)
      .on("value", doSetCardData);
    return () =>
      firebase
        .database()
        .ref(`people`)
        .off("value", doSetCardData);
  }, []);

  if (!cardData) {
    return null;
  }

  console.log({ cardData });
  return Object.entries(cardData).map(([key, entry]) => {
    console.log(entry);
    return (
      <CardList
        key={key}
        name={entry?.name ?? "NO NAME"}
        flipped={entry?.cardgame?.flipped ?? {}}
        preferred={entry?.cardgame?.preferred ?? {}}
      />
    );
  });
}

const NameTitle = styled.h1`
  font-size: 2rem;
  font-family: var(--title);
  color: var(--blue);
`;

function CardList({ name, preferred, flipped }) {
  console.log({ flipped });
  return (
    <div>
      <NameTitle>{name}</NameTitle>
      <ul>
        {CardFlipData.map(([front, back], i) => (
          <li
            key={i}
            style={{
              color: preferred[i] === (flipped[i] ? 0 : 1) ? "red" : "black"
            }}
          >
            {flipped[i] ? back : front}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function AdminView() {
  return (
    <div style={{ padding: "4rem" }}>
      <CardView />
      <hr />
      <button
        style={{ padding: "2rem", backgroundColor: "red" }}
        onClick={() => {
          firebase
            .database()
            .ref()
            .set(ResetData);
        }}
      >
        RESET ALL CLASSROOM DATA
      </button>
    </div>
  );
}
